import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  notifications: [],
  toasts: [],
  unreadCount: 0,
  settings: {
    enablePush: true,
    enableEmail: true,
    enableSMS: false,
    quietHours: {
      enabled: false,
      start: '22:00',
      end: '07:00',
    },
    categories: {
      events: true,
      milestones: true,
      health: true,
      growth: true,
      sharing: true,
    },
  },
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    addNotification: (state, action) => {
      const notification = {
        ...action.payload,
        id: action.payload.id || `notification_${Date.now()}_${Math.random()}`,
        read: false,
        createdAt: action.payload.timestamp || new Date().toISOString(),
      };
      
      state.notifications.unshift(notification);
      state.unreadCount += 1;
      
      // Keep only the last 200 notifications
      if (state.notifications.length > 200) {
        state.notifications = state.notifications.slice(0, 200);
      }
    },
    markAsRead: (state, action) => {
      const notificationId = action.payload;
      const notification = state.notifications.find(n => n.id === notificationId);
      
      if (notification && !notification.read) {
        notification.read = true;
        state.unreadCount = Math.max(0, state.unreadCount - 1);
      }
    },
    markAllAsRead: (state) => {
      state.notifications.forEach(notification => {
        notification.read = true;
      });
      state.unreadCount = 0;
    },
    removeNotification: (state, action) => {
      const notificationId = action.payload;
      const index = state.notifications.findIndex(n => n.id === notificationId);
      
      if (index !== -1) {
        const notification = state.notifications[index];
        if (!notification.read) {
          state.unreadCount = Math.max(0, state.unreadCount - 1);
        }
        state.notifications.splice(index, 1);
      }
    },
    clearNotifications: (state) => {
      state.notifications = [];
      state.unreadCount = 0;
    },
    showToast: (state, action) => {
      const toast = {
        ...action.payload,
        id: action.payload.id || `toast_${Date.now()}_${Math.random()}`,
        timestamp: new Date().toISOString(),
        duration: action.payload.duration || 5000,
      };
      
      state.toasts.push(toast);
    },
    hideToast: (state, action) => {
      const toastId = action.payload;
      state.toasts = state.toasts.filter(toast => toast.id !== toastId);
    },
    clearToasts: (state) => {
      state.toasts = [];
    },
    updateSettings: (state, action) => {
      state.settings = { ...state.settings, ...action.payload };
    },
    updateCategorySettings: (state, action) => {
      state.settings.categories = { ...state.settings.categories, ...action.payload };
    },
    updateQuietHours: (state, action) => {
      state.settings.quietHours = { ...state.settings.quietHours, ...action.payload };
    },
  },
});

export const {
  addNotification,
  markAsRead,
  markAllAsRead,
  removeNotification,
  clearNotifications,
  showToast,
  hideToast,
  clearToasts,
  updateSettings,
  updateCategorySettings,
  updateQuietHours,
} = notificationsSlice.actions;

export default notificationsSlice.reducer;